import { render, staticRenderFns } from "./shqy.vue?vue&type=template&id=82714bac&scoped=true"
import script from "./shqy.vue?vue&type=script&lang=js"
export * from "./shqy.vue?vue&type=script&lang=js"
import style0 from "./shqy.vue?vue&type=style&index=0&id=82714bac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82714bac",
  null
  
)

export default component.exports